export { Dashboard as default } from '@/screens/dashboard/Dashboard'
